import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useTranslation } from "@/hooks/useTranslation";
import * as React from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";

type FormStepConfirmDetailsProps = {
  onStepSubmit: () => void;
  message: string | React.ReactNode;
};

export function FormStepConfirmDetails(props: FormStepConfirmDetailsProps) {
  const { onStepSubmit, message } = props;
  const t = useTranslation("_common");

  const handleSubmit = () => {
    onStepSubmit();
    dispatchEvent(EventName.STEP_SUBMIT, {
      step_name: DetailsStep.ConfirmDetails,
      data: {},
    });
  };

  return (
    <div>
      <div className={classes.confirmMessage}>{message}</div>

      <div className={classes.pagination}>
        <Button size="large" onClick={handleSubmit}>
          {t("complete-donation")}
        </Button>
      </div>
    </div>
  );
}
